import { useMutation } from '@apollo/react-hooks';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { addToCartSuccess } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import uniqueId from '@jetshop/core/helpers/uniqueId';
import t, { useIntl } from '@jetshop/intl';
import React, { useContext } from 'react';
import { css } from 'linaria';
import { toast } from 'react-toastify';
import { addToCart } from '../Cart/addToCart.gql';
import ProductToastWrapper from '../ProductPage/AddToCart/ProductToast';
import { useTracking } from '../../utils/tracking/useTracking';
import { useElevate } from '../Elevate/ElevateContext';

const addButton = css`
  background: #235837;
  border: 0;
  color: #fff;
  display: block;
  font-size: 12px;
  font-weight: bold;
  margin: auto !important;
  outline: none;
  padding: 0.25rem 0.5em;
  text-align: center;
  text-transform: uppercase;
  transition: all ease 0.3s;
  width: calc(100% - 20px);
  :hover {
    background: #2b2b2b;
  }
`;

/**
 *
 * @param {object} props
 * @param {import('@jetshop/core/hooks/ProductList').ProductListProduct} props.product
 */
export function AddToCart({ product }) {
  const { cartId, setCartId } = useContext(CartIdContext);
  const { trackAddToCart } = useTracking();
  const { notification, NOTIFICATION_TYPES } = useElevate();
  const articleNumber = product.variant?.articleNumber || product.articleNumber;
  const price = {
    price: product.variant?.price || product.price,
    previousPrice: product.variant?.previousPrice || product.previousPrice
  };
  const translate = useIntl();
  const ariaLabel = translate('Add {productName} to cart', {
    productName: product?.name
  });

  const [add] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber,
        quantity: 1
      }
    },
    onCompleted: data => {
      // Track add to cart

      trackAddToCart({
        product,
        variant: product.variant || null,
        quantity: 1,
        placement: 'Product list'
      });

      toast(
        <ProductToastWrapper
          selectedVariation={product.variant}
          product={product}
          quantity={1}
          price={price}
        />,
        {
          autoClose: 2000,
          toastId: uniqueId()
        }
      );
      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });

  return (
    <button className={addButton} onClick={() => add()} aria-label={ariaLabel}>
      {t('Add to cart')}
    </button>
  );
}
